export function isArgomentoObbligatorio(categoria) {
  return categoria.argomenti && categoria.argomenti.length > 0;
}

export function existsSetInformazioniAggiuntive(categoria) {
  if (categoria) {
    if (categoria.EtichettaCampoAux1 || categoria.EtichettaCampoAux2) {
      return true;
    }
    if (isArgomentoObbligatorio(categoria)) {
      return true;
    }
  }
  return false;
}

export function getArgomentiCategoria(categoria = {}, categorie = []) {
  return categorie.filter((cat) => cat.IdCategoriaPadre === categoria.IdCategoria);
}
